import { render, staticRenderFns } from "./OperatnResidenza.vue?vue&type=template&id=789afa70&"
import script from "./OperatnResidenza.vue?vue&type=script&lang=ts&"
export * from "./OperatnResidenza.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports